import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Switch from '../../common/inputs/customs/switch';
import msnSpots from '@spotim/branding/spots/msn.json';

class RestrictedUNMode extends Component {
  render() {
    const { isRestrictedUNMode, onChange, spotId } = this.props;

    //TOOD remove when we add the feature globally
    if (msnSpots.indexOf(spotId) === -1) {
      return null;
    }

    return (
      <div>
        <Switch
          title="Restricted Usernames"
          description='Enable filtering and blocking usernames and display names that violate your community guidelines, enter restricted words under the "Moderation -> Words -> Restricted Usernames"'
          value={isRestrictedUNMode}
          onChange={onChange}
        />
      </div>
    );
  }
}

RestrictedUNMode.defaultProps = {
  isRestrictedUNMode: false
};

RestrictedUNMode.propTypes = {
  isRestrictedUNMode: PropTypes.bool.isRequired,
  spotId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

RestrictedUNMode.contextTypes = {
  executeAction: PropTypes.func
};

RestrictedUNMode.displayName = 'RestrictedUNMode';

export default RestrictedUNMode;
